import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useWindowSize from 'hooks/useWindowSize';
import storage from 'shared/storage';
import NavLayout from '../../layouts/NavLayout';
import NavMobileLayout from '../../layouts/NavMobileLayout';

const AdminRoute = ({ component: Component, backgroundColor, ...rest }) => {
  const [width] = useWindowSize();

  const { pathname, search } = useLocation();

  return (
    <Route
      {...rest}
      render={(props) => {
        const user = storage.get('user', {});

        if (typeof user.role !== 'undefined') {
          if (user.role !== 'admin') {
            return (
              <Redirect
                to={{
                  pathname: `${pathname.replace(
                    '/admin',
                    `/admin-${user.role}`
                  )}`,
                  state: { from: props.location },
                  search: search,
                }}
              />
            );
          }
        } else {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location },
              }}
            />
          );
        }

        return (
          // <AdminLayout>
          //   <Component {...props} />
          // </AdminLayout>

          <div>
            {width <= 860 ? (
              <NavMobileLayout backgroundColor={backgroundColor}>
                <Component {...props} />
              </NavMobileLayout>
            ) : (
              <NavLayout>
                <Component {...props} />
              </NavLayout>
            )}
          </div>
        );
      }}
    />
  );
};

export default AdminRoute;
